<template>
  <base-section id="what-we-do">
    <base-section-heading title="What We Do">

    </base-section-heading>

    <v-container>
      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="feature"
            align="left"
            horizontal
          >
            {{feature.text}}
          </base-avatar-card>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: 'SectionWhatWeDo',

  data: () => ({
    features: [
      {
        title: 'Repairs',
        icon: 'mdi-car-cog',
        text: 'Helderberg Propshaft specialises in the repair of all types of Propshafts, from light motor vehicles to heavy trucks and all agricultural applications.',
      },
      {
        title: 'Replacements',
        icon: 'mdi-car-multiple',
        text: 'Helderberg Propshaft keeps a wide range of replacements propshafts in stock, to facilitate an exchange service for customers who are pressed for time.This service is available at no extra cost!',
      },
      {
        title: 'Special Requests',
        icon: 'mdi-star',
        text: 'Helderberg Propshaft also specialises in the design and manufacturing of specialised propshafts. Specially built vehicles and modified vehicles for example, as well as special machinery and industrial applications.',
      },
      {
        title: 'Passenger Vehicles',
        icon: 'mdi-car-hatchback',
        text: 'We repair Driveshafts for all Rear Wheel Drive passenger vehicles, including imported vehicles.',
      },
      {
        title: 'Sport Utility Vehicles',
        icon: 'mdi-car-sports',
        text: 'We will fix the propshaft for all modern SUVs, but can also supply high quality new replacement products for most modern SUVs',
      },
      {
        title: 'Heavy Vehicles',
        icon: 'mdi-truck',
        text: 'We supply a service and balance for any Heavy Truck propshaft. If the parts are not in stock, arrangements can be made for overnight delivery to our premises.',
      },
    ],
  }),
};
</script>
